<template>
  <v-container fluid grid-list-lg class="linkedin-container">
    <v-layout row wrap class="linkedin-overlay">
      <v-flex xs12 sm12 md6 lg6 class="is-flex-column align-center justify-center white--text">
        <!-- <icon-base :width="80" :height="80" icon-name="linkedin"><icon-linkedin /></icon-base> -->
        <a href="https://www.linkedin.com/company/mc-consultant-sas/" target="_blank">
          <img src="@/assets/linkedin-original.svg" />
        </a>
        <a href="https://www.linkedin.com/company/mc-consultant-sas/" target="_blank">
          <h2 class="ma-0 px-0">Rejoignez-nous sur Linkedin !</h2>
        </a>
      </v-flex>
      <v-flex xs12 sm12 md6 lg6 class="is-flex row flex-wrap justify-start text-xs-center"
        :class="view.mdAndUp ? 'align-center py-5' : ' align-content-start'">
        <v-flex xs6 sm6 md10 lg8 :class="view.mdAndUp ? 'pr-5 text-xs-right' : 'px-0'">
          Actualités de l'entreprise
        </v-flex>
        <v-flex xs6 sm6 md10 lg8 :class="view.mdAndUp ? 'pr-5 text-xs-right' : 'px-0'">
          Articles thématiques
        </v-flex>
        <v-flex xs6 sm6 md10 lg8 :class="view.mdAndUp ? 'pr-5 text-xs-right' : 'px-0'">
          Veille juridique
        </v-flex>
        <v-flex xs6 sm6 md10 lg8 :class="view.mdAndUp ? 'pr-5 text-xs-right' : 'px-0'">
          Formation
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'linkedin-section',
  computed: {
    view () {
      return {
        mdAndUp: this.$vuetify.breakpoint.mdAndUp
      }
    }
  }
}
</script>

<style lang="stylus">
.container.grid-list-lg .layout:only-child
  margin: 0 !important

.linkedin-container
  width: 100%
  height: 350px
  background: rgba(0, 0, 0, 0.7) url('../../../public/linkedin.jpg') no-repeat center 15%
  background-size: 100%

.linkedin-overlay
  height: 100%
  width: 100%
  background: rgba(0, 0, 0, 0.7)

.linkedin-container img 
  width: 100px

.linkedin-container
  font-size: 1.6rem
  font-weight: 500
  color: white

.linkedin-container h2
  font-size: 1.6rem
  color: white

.linkedin-container a
  text-decoration: none

.linkedin-container a:hover
  color: gainsboro

/* Style for small viewport */
.smOnly .linkedin-container
  font-size: 1.3rem

.smOnly .linkedin-container img 
  width: 75px

.smOnly .linkedin-container h2
  font-size: 1.4rem

.smOnly .linkedin-container a
  margin-top: 12px

/* Style for extra small viewport */
.xsOnly .linkedin-container
  width: 100%
  height: 210px

// .xsOnly .linkedin-overlay:first-child
//   height: 230px

.xsOnly .linkedin-container
  font-size: 0.8rem

.xsOnly .linkedin-container img 
  width: 60px

.xsOnly .linkedin-container h2
  font-size: 1.1rem

.xsOnly .linkedin-container a
  margin-top: 6px

.xsOnly .linkedin-container a:first-child
  margin-top: 16px
</style>

